var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { action, flow, observable, onBecomeObserved, reaction, toJS, when } from "mobx";
import { Observer } from "mobx-react-lite";
import React from "react";
import { SHOULD_LOG } from "../../env";
import { useControllers } from "../../hooks/controller.hooks";
import { useOnMount } from "../../hooks/lifecycle.hooks";
import { useCreateResizeQueryWithRef } from "../../hooks/useCreateResizeQueryWithRef.hook";
import joinClassName from "../../utils/className.utils";
import { renderRenderable } from "../../utils/components.utils";
import { reportError } from "../../utils/errors.utils";
import { useProps, useStore } from "../../utils/mobx.utils";
import { capitalizeFirstLetter } from "../../utils/string.utils";
import { getNowTimestampUtc } from "../../utils/time.utils";
import { isFunction } from "../../utils/typeChecks.utils";
import tick from "../../utils/waiters.utils";
import BaseButton from "../BaseButton/BaseButton";
import BaseCalendar from "../BaseCalendar/BaseCalendar";
import { BaseCalendarState } from "../BaseCalendar/BaseCalendarState";
import BasePagination from "../BasePagination/BasePagination";
import BaseSelector from "../BaseSelector/BaseSelector";
import CommandList from "../CommandList/CommandList";
import { CommandListItem } from "../CommandList/CommandListItem";
import LoadingBlocker from "../LoadingBlocker/LoadingBlocker";
import './IndexDirectory.scss';
import IndexDirectoryState from "./IndexDirectoryState";
function IndexDirectory(props) {
    var _this = this;
    var p = useProps(props);
    var UI = useControllers().UI;
    var _a = useCreateResizeQueryWithRef(), ref = _a.ref, query = _a.query;
    var s = useStore(function () {
        var _a, _b, _c, _d, _e, _f;
        var _private = observable({
            state: observable(p.state || new IndexDirectoryState({
                viewMode: (_a = p.initInViewMode) !== null && _a !== void 0 ? _a : (_b = p.allowedViewModes) === null || _b === void 0 ? void 0 : _b[0],
                searchable: (_e = (_d = (_c = p.searchable) !== null && _c !== void 0 ? _c : !!p.searchBarPlaceholder) !== null && _d !== void 0 ? _d : !!p.searchQueryMatcher) !== null && _e !== void 0 ? _e : !!p.onSearchQueryChange,
            })),
            _internalEntries: new Set(),
            get entries() {
                return props.data ? new Set(isFunction(props.data) ? props.data() : props.data) : _private._internalEntries;
            },
            currentFetcher: null,
        });
        var store = observable({
            get state() {
                return _private.state;
            },
            get entries() {
                return _private.entries;
            },
            get isLocalDataMode() {
                return !!p.data && !p.dataFetcher;
            },
            calendarState: new BaseCalendarState((_f = p.calendarPropsGetter) === null || _f === void 0 ? void 0 : _f.call(p).state),
            get entriesArray() {
                var entriesArr = Array.from(_private.entries.values());
                if (p.entryFilter)
                    return entriesArr.filter(p.entryFilter);
                return entriesArr;
            },
            get calendarEvents() {
                var _a;
                if (!!((_a = p.calendarPropsGetter) === null || _a === void 0 ? void 0 : _a.call(p).eventBuilder)) {
                    return s.entriesArray.map(function (e) { return p.calendarPropsGetter().eventBuilder(e); });
                }
                else {
                    return [];
                }
            },
            get viewMode() {
                return _private.state.viewMode || 'table';
            },
            get allowedViewModes() {
                return p.allowedViewModes || ['table'];
            },
            get showAsList() {
                return Boolean(_private.state.viewMode === 'list' && p.listEntryRenderer);
            },
            get showAsCalendar() {
                return Boolean(_private.state.viewMode === 'calendar' && p.calendarPropsGetter);
            },
            get filteredEntries() {
                return s.entriesArray;
            },
            get paginatedEntries() {
                console.log('s.isLocalDataMode', s.isLocalDataMode);
                if (!s.isLocalDataMode)
                    return s.filteredEntries;
                var _a = s.state.paginationState, currentPage = _a.currentPage, perPage = _a.perPage;
                return s.entriesArray.slice((currentPage - 1) * perPage, currentPage * perPage);
            },
            get shouldShowPagination() {
                return _private.state.paginationState && _private.state.viewMode !== 'calendar';
            },
            get perPage() {
                var _a;
                return (_a = _private.state.paginationState) === null || _a === void 0 ? void 0 : _a.perPage;
            },
            get fillToNumberOfRows() {
                var _a;
                return Math.min(((_a = p.appearanceOptions) === null || _a === void 0 ? void 0 : _a.fullHeight) ? s.perPage : 0, 128);
            },
            get awaitingResponse() {
                return Boolean(_private.currentFetcher);
            },
            firstDataLoaded: false,
            lastFetchedTimestamp: null,
            isLoading: false,
            runDataFetcher: flow(function () {
                var fetcher;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!_private.state)
                                return [2 /*return*/];
                            if (!p.dataFetcher)
                                return [2 /*return*/];
                            if (_private.state.viewMode === 'calendar' && !!((_a = p.calendarPropsGetter) === null || _a === void 0 ? void 0 : _a.call(p).dataFetcher))
                                return [2 /*return*/];
                            fetcher = flow(function () {
                                var newEntries, e_1;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _b.trys.push([0, 3, 4, 5]);
                                            return [4 /*yield*/, tick()];
                                        case 1:
                                            _b.sent(); // waits for possible cancellation from overlapping requests
                                            SHOULD_LOG() && console.log('data fetcher running');
                                            SHOULD_LOG() && console.log(s.state.searchQuery);
                                            s.isLoading = true;
                                            return [4 /*yield*/, p.dataFetcher(_private.state)];
                                        case 2:
                                            newEntries = _b.sent();
                                            if (_private.currentFetcher && _private.currentFetcher !== fetcher)
                                                return [2 /*return*/];
                                            _private.entries.clear();
                                            newEntries.forEach(function (e) { return _private.entries.add(e); });
                                            s.lastFetchedTimestamp = getNowTimestampUtc();
                                            if (!s.firstDataLoaded) {
                                                (_a = p.onFirstDataLoad) === null || _a === void 0 ? void 0 : _a.call(p, newEntries);
                                                s.firstDataLoaded = true;
                                            }
                                            s.isLoading = false;
                                            return [3 /*break*/, 5];
                                        case 3:
                                            e_1 = _b.sent();
                                            s.isLoading = false;
                                            reportError(e_1);
                                            UI.DIALOG.error({
                                                heading: 'There was an error getting data. Please retry.',
                                                error: e_1,
                                            });
                                            return [3 /*break*/, 5];
                                        case 4:
                                            _private.currentFetcher = null;
                                            return [7 /*endfinally*/];
                                        case 5: return [2 /*return*/];
                                    }
                                });
                            })();
                            _private.currentFetcher = fetcher;
                            return [4 /*yield*/, when(function () { return _private.currentFetcher === null; })];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            }),
            runExportCSVDataFetcher: flow(function () {
                var state, newEntries, e_2;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!_private.state)
                                return [2 /*return*/];
                            if (!p.dataFetcher)
                                return [2 /*return*/];
                            if (_private.state.viewMode === 'calendar' && !!((_a = p.calendarPropsGetter) === null || _a === void 0 ? void 0 : _a.call(p).dataFetcher))
                                return [2 /*return*/];
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, tick()];
                        case 2:
                            _b.sent(); // waits for possible cancellation from overlapping requests
                            SHOULD_LOG() && console.log('export csv data fetcher running');
                            SHOULD_LOG() && console.log(s.state.searchQuery);
                            state = new IndexDirectoryState(toJS(_private.state));
                            state.searchQuery = _private.state.searchQuery;
                            state.sortByKeyName = _private.state.sortByKeyName;
                            state.sortDirection = _private.state.sortDirection;
                            state.paginationState.perPage = 999999;
                            return [4 /*yield*/, p.dataFetcher(state)];
                        case 3:
                            newEntries = _b.sent();
                            return [2 /*return*/, newEntries];
                        case 4:
                            e_2 = _b.sent();
                            reportError(e_2);
                            UI.DIALOG.error({
                                heading: 'There was an error getting data. Please retry.',
                                error: e_2,
                            });
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            }),
            handleSort: function (keyName, direction) {
                s.state.sortByKeyName = keyName;
                s.state.sortDirection = direction;
                s.runDataFetcher();
            },
            destroy: function () {
                destroy();
            },
            get listRendered() {
                var _a;
                return React.createElement("div", { className: "IndexDirectoryListWrapper" },
                    React.createElement("ul", { className: "IndexDirectoryList" },
                        s.filteredEntries.length === 0 && React.createElement("div", { className: "IndexDirectoryListEmptyListNotice" }, (_a = p.listEmptyNotice) !== null && _a !== void 0 ? _a : 'No entries to show here'),
                        s.filteredEntries.map(function (e, i, arr) { return React.createElement("li", { className: "IndexDirectoryListItem", key: e.id },
                            ListEntryRenderer(e),
                            p.listEntrySeparator && i !== arr.length - 1 && renderRenderable(p.listEntrySeparator)); })));
            },
            get calendarRendered() {
                var _a;
                // calendarPropsGetter has events, only omitted by TypeScript's types.
                // to override calendarPropsGetter's events, events={s.calendarEvents}
                // must be placed after it.
                var calendarProps = __assign(__assign({}, (_a = p.calendarPropsGetter) === null || _a === void 0 ? void 0 : _a.call(p)), { events: s.calendarEvents });
                return React.createElement(BaseCalendar, __assign({ key: s.calendarReloadKey, state: s.calendarState, onFirstDataLoad: props.onFirstDataLoad }, calendarProps, { eventDataFilter: p.entryFilter }));
            },
            get content() {
                if (s.showAsList)
                    return s.listRendered;
                if (s.showAsCalendar)
                    return s.calendarRendered;
                return null;
            },
            calendarReloadKey: 0,
            shouldReload: p.shouldTriggerReload,
            reload: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, flow(function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(s.state.viewMode === 'calendar')) return [3 /*break*/, 3];
                                            if (!p.dataFetcher) return [3 /*break*/, 2];
                                            return [4 /*yield*/, s.runDataFetcher()];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2:
                                            s.calendarReloadKey++;
                                            return [3 /*break*/, 4];
                                        case 3:
                                            s.runDataFetcher();
                                            _a.label = 4;
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            })()];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            }); }
        });
        var disposerOne = onBecomeObserved(_private, 'entries', store.runDataFetcher);
        var disposerTwo = reaction(function () { return _private.state.viewMode; }, function () {
            store.runDataFetcher();
        });
        var disposerThree = reaction(function () { return store.shouldReload; }, action(function () {
            if (store.shouldReload) {
                store.reload();
            }
        }));
        var destroy = function () {
            disposerOne();
            disposerTwo();
            disposerThree();
        };
        return store;
    });
    useOnMount(function () {
        var disposer = reaction(function () { return p.dataFetcher; }, function () {
            s.runDataFetcher();
        });
        return function () {
            disposer();
            s.destroy();
        };
    });
    var handlePaginationChange = action(function (number) {
        s.runDataFetcher();
        p.onPaginationChange && p.onPaginationChange(number);
    });
    var ListEntryRenderer = p.listEntryRenderer || (function (e) { return e && e.id; });
    return React.createElement(Observer, { children: function () {
            var _a;
            var className = p.className;
            var paginationState = s.state.paginationState;
            return React.createElement("div", { className: joinClassName('IndexDirectory', className, ((_a = p.appearanceOptions) === null || _a === void 0 ? void 0 : _a.fullHeight) && 'fullHeight'), "data-mode": s.viewMode, ref: ref, "data-loading": s.isLoading },
                React.createElement("div", { className: "IndexDirectoryControls" }, s.allowedViewModes.length > 1 && React.createElement(CommandList, { direction: "row", startSlot: React.createElement(React.Fragment, null,
                        React.createElement(CommandListItem, null,
                            React.createElement(BaseSelector, { className: "IndexDirectoryViewModeSelector", options: s.allowedViewModes, form: s.state, field: "viewMode", optionLabelRenderer: capitalizeFirstLetter, nullable: false }))), endSlot: React.createElement(React.Fragment, null,
                        p.EndCommandListItems && p.EndCommandListItems(),
                        p.dataFetcher && React.createElement(BaseButton, { className: "IndexDirectoryRefreshButton", appearance: "icon", icon: "refresh", size: "sm", iconVariant: "filled", onClick: s.reload }),
                        p.entryCreator && (!p.doNotShowCreateButtonInOptions) && React.createElement(CommandListItem, { icon: "plus", onClick: p.entryCreator }, p.createEntryButtonText || 'Add New')) })),
                React.createElement("div", { className: "IndexDirectoryContent" }, s.content),
                s.shouldShowPagination &&
                    React.createElement("div", { className: "IndexDirectoryFooter" }, s.shouldShowPagination && React.createElement(BasePagination, { paginationState: paginationState, onChange: handlePaginationChange })),
                s.isLoading && React.createElement(LoadingBlocker, null));
        } });
}
export default React.memo(IndexDirectory);
